

import React, { memo } from 'react';
import Icon from '../../Icon';
import { ERROR_TOOLTIP } from '../styles';
import errorColours from '../constants/errorColours';













/**
 * An Error Icon React component. Renders an 'alert' icon that will display an error message popup
 * if the error message prop is passed.
 *
 * @return {React.Element}
 */
function ErrorIcon(
{ className, errorMessage, size, id, tooltipProps: { place, type } })
{
  // We have to use important to override these styles because the library uses inline styling
  const COLOUR = type === 'warning' ? errorColours.WARNING.COLOUR : errorColours.ERROR.COLOUR;
  const TEXT = type === 'warning' ? errorColours.WARNING.TEXT : errorColours.ERROR.TEXT;

  return (
    <Icon
      color={type === 'warning' ? 'mandarin' : 'thunderBird'}
      className={className}
      name="alert"
      size={size}
      tooltipId={errorMessage ? id : void 0}
      tooltipLabel={errorMessage}
      tooltipPlace={place}
      tooltipClass={ERROR_TOOLTIP(COLOUR, TEXT)} />);


}

ErrorIcon.defaultProps = {
  tooltipProps: {},
  size: 15
};

export default memo(ErrorIcon);